/**
 * Placeholder del bloque Equipo del panel de Membresía mientras carga
 * `GET /membresia/equipo`.
 *
 * El bloque Plan viene del contexto (ya cargado al entrar) y el Equipo de
 * una query aparte: sin esto, el panel pintaba el Plan y el Equipo aparecía
 * unos segundos después sin ninguna señal, como si la pantalla estuviera
 * incompleta (hallazgo del founder, 7-sep-2026). Reserva la misma forma
 * que el contenido real -- formulario de invitar si es admin y dos filas
 * de miembros -- para que nada salte cuando llegan los datos.
 */
export function EquipoSkeleton({ conFormulario }: { conFormulario: boolean }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-testid="equipo-skeleton"
      className="motion-safe:animate-pulse"
    >
      <span className="sr-only">Cargando el equipo…</span>
      {conFormulario && (
        <div aria-hidden="true" className="mb-4 flex gap-2">
          <div className="h-10 flex-1 rounded-md bg-slate-100" />
          <div className="h-10 w-32 rounded-md bg-slate-100" />
          <div className="h-10 w-20 rounded-md bg-slate-200" />
        </div>
      )}
      <ul aria-hidden="true" className="divide-y divide-slate-100">
        {[0, 1].map((fila) => (
          <li key={fila} className="flex items-center justify-between py-3">
            <div className="space-y-2">
              <div className="h-3.5 w-40 rounded bg-slate-200" />
              <div className="h-3 w-28 rounded bg-slate-100" />
            </div>
            <div className="h-5 w-16 rounded-full bg-slate-100" />
          </li>
        ))}
      </ul>
    </div>
  );
}
